import { EntityTypes } from "@vzbl/integrations";
import { TabbedWork, TabbedWorkItems } from "../components/TabbedWork";
import { generateWorkTabs } from "../components/worktabs";

export function Comment(props: { entity: any }) {
  const orgId = props.entity.properties.orgId;
  const workTabsItems: TabbedWorkItems[] = generateWorkTabs(
    orgId,
    props.entity.properties.uuid,
    [
      { entityTypes: EntityTypes.Sprint },
      { entityTypes: EntityTypes.IssueComment, label: "Comments" },
      { entityTypes: EntityTypes.Commit },
      { entityTypes: EntityTypes.PullRequest, label: "Pull Requests" },
      { entityTypes: EntityTypes.CicdPipeline, label: "Deployments" },
    ]
  );
  return <TabbedWork title="Work" items={workTabsItems} />;
}
